import isSSR from '@/utils/isSSR';
import logger from '@/app/logger';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { onServerPrefetch, type Ref } from 'vue';
import { landingPagesQuery_Client } from './landingPages.client';

export const opLandingPagesQueryKey = 'opLandingPages';

const queryFn = async (section?: string) => {
  if (isSSR) {
    const { landingPagesQuery_Server } = await import('@/server/data/landingPages.server');
    return landingPagesQuery_Server(section);
  } else {
    return landingPagesQuery_Client(section);
  }
};
export default function useLandingPagesDataNew() {
  logger.info('useLandingPagesDataNew');
  const query = useQuery({
    queryKey: [opLandingPagesQueryKey],
    queryFn: () => queryFn(),
  });

  onServerPrefetch(async () => {
    const queryClient = useQueryClient();
    await queryClient.prefetchQuery({ queryKey: [opLandingPagesQueryKey] });
  });

  return query;
}
export function useLandingPageDataNew(section: Ref<string>) {
  logger.info('useLandingPageDataNew', { sectionValue: section.value || '' });
  const query = useQuery({
    queryKey: [opLandingPagesQueryKey, section],
    queryFn: () => queryFn(section.value).then((queryData) => queryData.data[0]),
  });

  onServerPrefetch(async () => {
    const queryClient = useQueryClient();
    await queryClient.prefetchQuery({ queryKey: [opLandingPagesQueryKey, section] });
  });

  return query;
}
